import axios from 'axios';
import store from '@/framework/store';
import { Notification, Message } from 'element-ui';
import router from '@/router';
// import jsonlint from '@/framework/jsonlint/jsonlint.js' // 解决精度丢失问题 重新定义一个JSON.parse
// create axios instance
let instance = null;

let baseURL = process.env.NODE_ENV === 'development' ? '/' : '/'


instance = axios.create({
  baseURL, // api context
  transformResponse: [function (data) {
    // console.log('data---', jsonlint.parse(data))
    // console.log('data before---', data)
    return jsonlint.parse(data)
  }]
});

instance.defaults.timeout = 50000; // timeout

// request interceptors
instance.interceptors.request.use(
  // request => {
  //   //   return request;
  //   // },
  config => {
    // console.log(store.state.user)
    // if token exist, add Access-Token to request header
    // if (store.state.user.token) {
    //   config.headers['Authorization'] = store.state.user.token;
    //   // config.headers['id'] = store.state.user.id;
    // } else {
    //   let result = store.dispatch("GET_USER_EXIST");
    //   result.then((flag) => {
    //     if (flag) {
    //       store.dispatch("GET_USER_CACHE");
    //       if (store.state.user.token) {
    //         config.headers['Access-Token'] = store.state.user.token;
    //         // config.headers['id'] = store.state.user.id;
    //       }

    //     }
    //   })
    // }
    return config;
  },
  error => {
    // Do something with request error
    console.log("request", error);
    Notification({
      title: '错误',
      message: '这是一条错误的提示消息',
      type: 'error'
    });
    Promise.reject(error);
  },
);


// response interceptors response data format {code: 200, data: {}} or {code: 400, message: "error"}
instance.interceptors.response.use(
  response => {
    let res = response.data;
    let code = response.status;
    if (code) {
      if (code  === 200) {
        let data = res;
        if (data === undefined || data === '' || data === null) {
          data = 0
        }
        return data
      } else if (code === 401 || code === 407) {
        // handle token is expired
        router.push("/login")
        store.dispatch('CLEAR_USER_CACHE')
        Notification({
          title: '警告',
          message: `请重新登录`,
          type: 'warning'
        })
      }  else if ( code == 400) {
        router.push("/login")
        store.dispatch('CLEAR_USER_CACHE')
        // 逻辑操作
        if (document.getElementsByClassName('el-message').length === 0) {
          Message({
            showClose: true,
            message: `${res.msg}`,
            type: 'warning',
            duration: 1000
          });
        }
      } else {
        // handle code is not 200
        Message({
          showClose: true,
          message: `${res.msg}`,
          type: 'warning',
          duration: 1000
        });
        return 'error'
        // Notification({
        //   title: '警告',
        //   message: `${res.message}`,
        //   type: 'warning'
        // })
        // return 'error'
      }
    }
  },
);

export default instance;



// WEBPACK FOOTER //
// ./src/framework/http/axios.js